import { useSyncExternalStore } from 'react';
import { isBrowserOffline, isConnectivityLost, subscribeConnectivity } from '@clarix/utils';

export type OfflineReason = 'no-network' | 'no-internet';

/**
 * Reports whether the user has a usable connection.
 *
 * Not just `navigator.onLine` — that stays `true` on a wifi with no internet.
 * Backed by the `@clarix/utils` connectivity store, which also flips offline
 * when a failed API call's reachability probe finds no internet, and recovers
 * on its own. `reason` says which: the device has no network at all, or it is
 * connected but the internet is unreachable.
 */
export function useNetworkStatus(): { isOnline: boolean; reason: OfflineReason | null } {
  const lost = useSyncExternalStore(subscribeConnectivity, isConnectivityLost, () => false);
  if (!lost) return { isOnline: true, reason: null };
  return { isOnline: false, reason: isBrowserOffline() ? 'no-network' : 'no-internet' };
}
